import vue from "vue";
const Modal = () => import(/* webpackPrefetch: true */'./Modal.vue')

vue.component("Modal", Modal);